import { CHART_TYPE_OPTIONS } from '../../../forms/Report/Params.form';

export const CHART_TYPE_ICON_SIZE = 16;
export const DEFAULT_CHART_TYPE = CHART_TYPE_OPTIONS[0].value;
export const DEFAULT_GROUP = 'job';
export const READABLE_ROWS_COUNT = 15;
export const DOWNLOAD_ICON_SIZE = 18;
